var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeaderComponent',{on:{"logout":_vm.logout}}),_c('ServicesComponent',{ref:"services"}),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }